export const PLANNING = 'orders-groups-planning/PLANNING';
export const planningAction = payload => ({
	type: PLANNING,
	payload,
});

export const SET_IS_PLANNING_LOADING = 'orders-groups-planning/SET_IS_PLANNING_LOADING';
export const setIsPlanningLoadingAction = payload => ({
	type: SET_IS_PLANNING_LOADING,
	payload,
});

export const GET_CONFIGS = 'orders-groups-planning/GET_CONFIGS';
export const getConfigsAction = payload => ({
	type: GET_CONFIGS,
	payload,
});

export const SET_CONFIGS = 'orders-groups-planning/SET_CONFIGS';
export const setConfigsAction = payload => ({
	type: SET_CONFIGS,
	payload,
});

export const SET_IS_CONFIGS_LOADING = 'orders-groups-planning/SET_IS_CONFIGS_LOADING';
export const setIsConfigsLoadingAction = payload => ({
	type: SET_IS_CONFIGS_LOADING,
	payload,
});

export const GET_TRANSPORT_TYPES = 'orders-groups-planning/GET_TRANSPORT_TYPES';
export const getTransportTypesAction = payload => ({
	type: GET_TRANSPORT_TYPES,
	payload,
});

export const SET_TRANSPORT_TYPES = 'orders-groups-planning/SET_TRANSPORT_TYPES';
export const setTransportTypesAction = payload => ({
	type: SET_TRANSPORT_TYPES,
	payload,
});

export const SET_IS_TRANSPORT_TYPES_LOADING = 'orders-groups-planning/SET_IS_TRANSPORT_TYPES_LOADING';
export const setIsTransportTypesLoadingAction = payload => ({
	type: SET_IS_TRANSPORT_TYPES_LOADING,
	payload,
});

export const GET_ORDER_GROUP_INFO = 'orders-groups-planning/GET_ORDER_GROUP_INFO';
export const getOrderGroupInfoAction = payload => ({
	type: GET_ORDER_GROUP_INFO,
	payload,
});

export const SET_ORDER_GROUP_INFO = 'orders-groups-planning/SET_ORDER_GROUP_INFO';
export const setOrderGroupInfoAction = payload => ({
	type: SET_ORDER_GROUP_INFO,
	payload,
});

export const SET_ORDER_GROUP_INFO_LOADING = 'orders-groups-planning/SET_ORDER_GROUP_INFO_LOADING';
export const setOrderGroupInfoLoadingAction = payload => ({
	type: SET_ORDER_GROUP_INFO_LOADING,
	payload,
});

export const GET_MODES = 'orders-groups-planning/GET_MODES';
export const getModesAction = payload => ({
	type: GET_MODES,
	payload,
});

export const SET_MODES = 'orders-groups-planning/SET_MODES';
export const setModesAction = payload => ({
	type: SET_MODES,
	payload,
});

export const SET_IS_MODES_LOADING = 'orders-groups-planning/SET_IS_MODES_LOADING';
export const setIsModesLoadingAction = payload => ({
	type: SET_IS_MODES_LOADING,
	payload,
});
export const GET_AUTOPARKS = 'orders-groups-planning/GET_AUTOPARKS';
export const getAutoparksAction = payload => ({
	type: GET_AUTOPARKS,
	payload,
});

export const SET_AUTOPARKS = 'orders-groups-planning/SET_AUTOPARKS';
export const setAutoparksAction = payload => ({
	type: SET_AUTOPARKS,
	payload,
});

export const SET_IS_AUTOPARKS_LOADING = 'orders-groups-planning/SET_IS_AUTOPARKS_LOADING';
export const setIsAutoparksLoadingAction = payload => ({
	type: SET_IS_AUTOPARKS_LOADING,
	payload,
});
export const GET_TARIFF_TYPES = 'orders-groups-planning/GET_TARIFF_TYPES';
export const getTariffTypesAction = payload => ({
	type: GET_TARIFF_TYPES,
	payload,
});

export const SET_TARIFF_TYPES = 'orders-groups-planning/SET_TARIFF_TYPES';
export const setTariffTypesAction = payload => ({
	type: SET_TARIFF_TYPES,
	payload,
});

export const SET_IS_TARIFF_TYPES_LOADING = 'orders-groups-planning/SET_IS_TARIFF_TYPES_LOADING';
export const setIsTariffTypesLoadingAction = payload => ({
	type: SET_IS_TARIFF_TYPES_LOADING,
	payload,
});

export const RESET_STATE = 'orders-groups-planning/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
